(function ($) {
    if ($('section.development-houses-modal').length || $('.modal-nature').length) {
        //swiper development houses carousel (preview)
        var swiperDevelopmentsHousesModal = new Swiper('.swiper.development-houses-modal', {
            pagination: {
                el: '.swiper-pagination-fraction',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            keyboard: {
                enabled: true,
            },
            slidesPerView: 2,
            spaceBetween: 10,
            loop: true,
            slidesPerGroup: 1,
            loopFillGroupWithBlank: true,
            // simulateTouch: false,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 30
                },
                800: {
                    slidesPerView: 1.65,
                    spaceBetween: 20
                },
            }
        });
       let modalNatureSwiper = new Swiper('.modal-nature .modal-nature-swiper', {
            spaceBetween: 30,
            autoHeight: true,
            loop: false,
            keyboard: {
                enabled: true,
                onlyInViewport:true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
           observer: true,
           observeParents: true,
           simulateTouch: false,
        });

        modalNatureSwiper.on('slideChange', function () {
            if (window.location.hash.includes("modal-slider")) {
                window.location.hash = `modal-slider-${$(this.slides[this.activeIndex]).data('gallery')}`
            }
        });

        let number = 0;
        $('body').on('click','.development-houses-modal .link',function(e){
            number = $(this).data('slider');
            modalNatureSwiper.slideTo(number)
            window.location.hash = $(this).data('gallery');
            $('.modal-nature').addClass('active');
            $('body').addClass('overflow-hidden');
        })

        $(window).on('hashchange', function() {
            if (window.location.hash.includes("modal-slider")) {
                if (!window.location.hash) {
                    $('.modal-nature ').removeClass('active');
                    $('body').removeClass('overflow-hidden');
                } else {
                    const targetWorker = window.location.hash.split('modal-slider-')[1];
                    if (targetWorker) {
                        modalNatureSwiper.slideTo($(modalNatureSwiper.slides).filter(`[data-gallery=${targetWorker}]`).index(), 0);
                        window.location.hash = `modal-slider-${targetWorker}`;
                        $('.modal-nature').addClass('active');
                        $('body').addClass('overflow-hidden');
                    }

                }
            }
        })
        if (window.location.hash.includes("modal-slider")) {
            $('body').addClass('overflow-hidden');
            $('.modal-nature').addClass('active');
            const targetWorker = window.location.hash.split("modal-slider-")[1];

            setTimeout(function() {
                modalNatureSwiper.slideTo($(modalNatureSwiper.slides).filter(`[data-gallery=${targetWorker}]`).index(), 0);
            }, 1)
        }
         $('body').on('click','.modal-nature .close-button',function(e){
             $('.modal-nature.active').removeClass('active');
             $('body.overflow-hidden').removeClass('overflow-hidden');
             window.history.pushState('', '/', window.location.pathname)
         })

    if($('.modal-nature .swiper-slide.faq-slide-type.swiper-slide-active')) {
        $('.modal-nature .faq-block .question').each(function( index ) {
           let faqHeight = $(this).parents('.faq-block').height();
           $(this).siblings('.answer').hide();
            $(this).on('click', function () {
                $(this).parent().toggleClass('active').find('.answer').slideToggle();
                if($(this).parents('.faq-block').hasClass('active')) {
                    $(this).parents('.swiper-wrapper').siblings('.swiper-buttons').animate({marginTop: faqHeight + 30}, 600, function () {
                    });
                }else {
                    $(this).parents('.swiper-wrapper').siblings('.swiper-buttons').animate({marginTop: 56}, 600, function () {
                    });
                }
            })
        });
    }
    }
})(jQuery);